import { render, staticRenderFns } from "./MateriaDetalle.vue?vue&type=template&id=30c30659&scoped=true"
import script from "./MateriaDetalle.vue?vue&type=script&lang=js"
export * from "./MateriaDetalle.vue?vue&type=script&lang=js"
import style0 from "./MateriaDetalle.vue?vue&type=style&index=0&id=30c30659&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c30659",
  null
  
)

export default component.exports